export default __webpack_public_path__ + "static/media/hrvatskaPosta-logo.a0ecdc1c.png";